var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('el-dialog', {
    attrs: {
      "visible": _vm.showSetting,
      "modal-append-to-body": false,
      "width": "820px",
      "custom-class": _vm.returnClass,
      "top": "8vh"
    },
    on: {
      "open": function ($event) {
        return _vm.initData();
      }
    }
  }, [_c('el-tabs', {
    attrs: {
      "tab-position": _vm.tabPosition
    },
    model: {
      value: _vm.tabVal,
      callback: function ($$v) {
        _vm.tabVal = $$v;
      },
      expression: "tabVal"
    }
  }, _vm._l(_vm.tabArray, function (item) {
    return _c('el-tab-pane', {
      key: item.label,
      attrs: {
        "label": _vm._f("showTabItems")(item.label),
        "name": item.name
      }
    }, [_c('span', {
      class: {
        grayColor: item.disabled
      },
      attrs: {
        "slot": "label"
      },
      on: {
        "click": function ($event) {
          return _vm.handClick(item);
        }
      },
      slot: "label"
    }, [_vm._v(_vm._s(_vm._f("showTabItems")(item.label)))]), item.label != 'Setting' ? _c('SettingHead', {
      attrs: {
        "tabName": item.name
      },
      on: {
        "callback": _vm.closeSettingDialog
      }
    }) : _vm._e(), item.disabled ? _c('div', {
      staticClass: "tips"
    }) : _c(item.content, {
      ref: `${item.content}`,
      refInFor: true,
      tag: "component",
      attrs: {
        "initResolution": _vm.initResolution,
        "initAnyWhereGlobalSetting": _vm.initAnyWhereGlobalSetting,
        "mainWindowType": _vm.mainWindowType,
        "tabVal": _vm.tabVal,
        "showSetting": _vm.showSetting,
        "statusInfo": _vm.statusInfo,
        "initAudioMatrixEnable": _vm.audioMatrixEnable,
        "initParticipantEnable": _vm.participantEnable,
        "initOperateData": _vm.initOperateData
      },
      on: {
        "mutexTip": _vm.mutexTip,
        "changeButtonFlag": _vm.changeButtonFlag,
        "callback": _vm.closeSettingDialog
      }
    })], 1);
  }), 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };